<template>
    <div>
        <van-nav-bar    title="新闻列表"  left-text="返回" @click-left="back"    left-arrow/>
        <van-list  class='pt46' v-model="loading"  :error.sync="error"  error-text="请求失败，点击重新加载" :finished='finished'  finished-text="没有更多了"  @load="getNewsList">
            <van-pull-refresh v-model="isRefresh" @refresh="onRefresh" loading-text='加载中...'>
                <van-cell  v-for="(item,index) in newsList" :key="index" :title="item.title" @click="toDetails(item)"  />
            </van-pull-refresh>
        </van-list>
    </div>
</template>

<script>
import {getNewsList} from '@/request/data'
export default {
    name:'newsList',
    data() {
        return {
            newsList:[],
            page:0,
            per_page:15,
            loading:false,
            error:false,
            finished:false,
            isRefresh:false,
        }
    },
    mounted() {        
        this.newsList = []
        this.getNewsList()
    },
    methods: {
        getNewsList(){            
            this.loading = true
            let data = {}
            this.page +=1
            data.page = this.page
            data.per_page = this.per_page
            getNewsList(data).then(res=>{
                this.loading = false
                this.isRefresh = false
                if (res.data.code == 0) {                    
                    if (res.data.data.data.length > 0) {
                        for (let i = 0; i < res.data.data.data.length; i++) {
                            this.newsList.push(res.data.data.data[i])                            
                        }
                        // this.newsList.push.apply(res.data.data.data)
                    }else{
                        this.finished = true
                    }
                }
                
            })
        },
        onRefresh(){
            this.isRefresh = true
            this.finished = false
            this.newsList = []
            this.page = 0
            this.getNewsList()                   
           
        },
        toDetails(item){
            
            this.$router.push({name:'articleDetails',query:{id:item.id}});              
        },
        back(){
            this.$router.back(-1)
        }
    },
}
</script>

<style  scoped>
.main{ position:relative; width:100%; top:46px; bottom:0;overflow:auto;}
</style>